module.exports = __webpack_public_path__ + "img/download.02bb7efd.jpg";